import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

const SECTIONS = [
  { key: "profile", label: "Profile" },
  { key: "evaluation", label: "Evaluation" },
  { key: "draft-plan", label: "Draft Plan" },
  { key: "team-fits", label: "Team Fits" },
  { key: "comparison-board", label: "Comparison Board" },
  { key: "interview-prep", label: "Interview Prep" },
  { key: "reports", label: "Reports" },
  { key: "documents", label: "Documents" },
];

export function PlayerSubNav() {
  const { playerId } = useParams();
  const { user } = useAuth();
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    if (!playerId) return;
    api.get(`/players/${playerId}`).then((r) => setPlayer(r.data)).catch(() => {});
  }, [playerId]);

  if (!playerId || user?.role !== "admin") return null;

  return (
    <div className="mb-4 flex items-center gap-3 flex-wrap" data-testid="player-sub-nav">
      <Link to="/app/players" className="text-3 hover:text-white text-xs flex items-center gap-1">
        <ChevronLeft className="h-3.5 w-3.5" /> Roster
      </Link>
      {player && <div className="text-1 text-sm font-medium">{player.full_name}</div>}
      <div className="flex flex-wrap gap-1.5">
        {SECTIONS.map((s) => (
          <NavLink
            key={s.key}
            to={`/app/players/${playerId}/${s.key}`}
            data-testid={`subnav-${s.key}`}
            className={({ isActive }) =>
              `rounded-full px-3 py-1 text-xs ring-1 transition ${
                isActive ? "ring-cyan-300/40 bg-cyan-300/10 text-cyan-200" : "ring-white/10 text-2 hover:text-white hover:bg-white/[0.05]"
              }`
            }
          >
            {s.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
